import React, { PropsWithChildren, ReactElement } from 'react';
import { Content, FlexboxGrid, Col, Grid, Row, Text } from 'rsuite';
import PortalHeader from './PortalHeader';
import PageButtons from './PageButtons';

interface GeneralPageLayoutProps {
  flow?: string;
  title?: string;
  showNext?: boolean;
  showBack?: boolean;
  next?: string;
  back?: string;
  showAccountDropdown?: boolean;
}

const GeneralPageLayout = ({
  flow,
  children,
  title,
  showAccountDropdown,
  ...buttons
}: PropsWithChildren<GeneralPageLayoutProps>): ReactElement => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader
          flow={flow}
          showAccountDropdown={showAccountDropdown}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Grid
            className="mt-24"
            fluid
          >
            <Row role="presentation">
              <Col
                role="presentation"
                xs={24}
              >
                <Grid className="mt-24 sm-mt-0 pv-24 sm-pb-0">
                  <Row>
                    <Col
                      xs={24}
                      lg={24}
                    >
                      {title && (
                        <Text
                          className="header-text-h3 mb-24"
                          style={{ marginLeft: '-3px' }}
                        >
                          {title}
                        </Text>
                      )}
                      <div className="content-section">{children}</div>
                      <PageButtons {...buttons} />
                    </Col>
                  </Row>
                </Grid>
              </Col>
            </Row>
          </Grid>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default GeneralPageLayout;
